import { isEmpty } from 'Data/format.js'
export function getPrompt(value) {
  return value === 'responsiblePersonContactDetails'
    ? 'What is the phone number of the person responsible for the patient?'
    : "What is the patient's phone number?"
}

export function markAsInvalid(isValid, value) {
  return isEmpty(value) || isValid
}
